import type { CollectionSummaryAssetType, CollectionSummaryJSONObject } from '@ikegps/core-api';
import { AppStore } from '../../store';

/**
 * Returns the asset type to display for a collection summary.
 * - If the full collection model is loaded, recompute from live data (the user may be mid-edit, before
 *   save) and update the cached summary value — mirrors `getShowRedDot`'s live/stale hybrid, so the
 *   Jobs-list dot/icon reflects an in-progress asset type edit the same way the map already does.
 * - If the collection is NOT loaded, use the summary's own (possibly stale) value as-is.
 */
export function getLiveAssetType(summary: CollectionSummaryJSONObject): CollectionSummaryAssetType | null {
	const collection = AppStore.Collection.get(summary.revision);
	if (collection != null) {
		summary.assetType = collection.assetType;
	}
	return summary.assetType ?? null;
}
